"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M23 11.9999c0 3.0375-1.2312 5.7875-3.2218 7.7781l-1.4142-1.4142C19.9926 16.7351 21 14.4851 21 11.9999c0-2.4853-1.0074-4.7353-2.636-6.364l1.4142-1.4142C21.7688 6.2123 23 8.9623 23 11.9999z"
  }), _react.default.createElement("path", {
    d: "M19.5 11.9999c0 2.071-.8395 3.946-2.1967 5.3033l-1.4142-1.4143c.9953-.9953 1.6109-2.3703 1.6109-3.889 0-1.5188-.6156-2.8938-1.6109-3.8891l1.4142-1.4142C18.6605 8.0538 19.5 9.9288 19.5 11.9999zM6.6967 17.3032l1.4142-1.4143C7.1156 14.8936 6.5 13.5186 6.5 11.9999c0-1.5188.6156-2.8938 1.611-3.8891L6.6966 6.6966C5.3395 8.0538 4.5 9.9288 4.5 11.9999c0 2.071.8395 3.946 2.1967 5.3033z"
  }), _react.default.createElement("path", {
    d: "M3 11.9999c0-2.4853 1.0074-4.7353 2.636-6.364L4.2218 4.2217C2.2312 6.2123 1 8.9623 1 11.9999c0 3.0375 1.2312 5.7875 3.2218 7.7781l1.4142-1.4142C4.0074 16.7351 3 14.4851 3 11.9999zm11.9985-.0004L10 16V8l4.9985 3.9995z"
  })];
};

exports.default = _default;